import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";
import BookingOfferShiftReply from "@/models/BookingRoleWorkerShifts/BookingOfferShiftReply";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class ConfirmAppliedBookingRoleWorkerRequest extends BaseUpdateRequest {
    isApplication: boolean;
    declinedReason: ShiftDeclinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
    replies: BookingOfferShiftReply[] = [];
}